import React, { memo } from 'react';
import { CardMedia, Typography } from '@one-thd/sui-atomic-components';
import { generateImageUrl } from '../../../../utils/general';
import { CustomImage } from '../../../shared/CustomImage';
var CancelLineitemsView = memo(
// eslint-disable-next-line react/prop-types
function (_a) {
    var lineItems = _a.lineItems;
    return (React.createElement(React.Fragment, null, lineItems.map(function (item, index) {
        var _a;
        return (React.createElement("div", { "data-testid": "lineitems", key: index, className: "sui-flex sui-mb-4" },
            React.createElement("div", { className: "sui-mr-4 sui-mt-1" },
                React.createElement("div", { style: { width: '70px', height: '70px' } },
                    React.createElement(CardMedia, { component: function () {
                            var _a;
                            return (React.createElement(CustomImage, { src: (_a = generateImageUrl(item)) !== null && _a !== void 0 ? _a : '', alt: item === null || item === void 0 ? void 0 : item.description, lazy: true }));
                        } }))),
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Typography, null,
                    React.createElement("span", { className: "sui-font-bold sui-pr-1" }, (_a = item.brandName) === null || _a === void 0 ? void 0 : _a.toUpperCase()),
                    React.createElement("span", null, item.description ? item.description : '')),
                React.createElement("div", { className: "sui-mt-2 " },
                    React.createElement(Typography, null,
                        "Qty: ",
                        item.currentQuantity)))));
    })));
});
export default CancelLineitemsView;
